import { WAY_UP_DEF_IMG } from '../const/way_up';
import { format_price_intl, getPrice } from "../utils/format_price";
import { conjugation } from '../utils/conjugation.js';
import { is_with_facing } from '../utils/facing.js';
import { get_promo_url } from '../utils/get_promo_url.js';

const promo_url = get_promo_url()

export const get_template_card_object_tiles_notype = (data) => {
  const picture_2d_layout = data.picture_simple_2d ?? data.get_picture_2d
  const mini_picture_2d_layout = data.mini_picture_simple_2d ?? data.mini_picture_2d
  return `
    <div class="card flat-card ${data.status === "BOOKED" ? 'card-blocked' : ''}">
      <div class="objects-table-link">
        <a class="" href="${data.absolute_url}" target="_blank"></a>
      </div>

      <div class="card">
        <div class="flat-card__buttons">
          <div class="flat-card__comparison flat-card__comparison--z-0">
            <button class="btn btn_comparison js-btn_comparison" data-id="${data.id}">
              <i class="icon icon_comparison">
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M17.619 10.125C17.6174 10.0945 17.6121 10.0642 17.6032 10.035C17.6016 10.0142 17.5981 9.99364 17.5927 9.9735L14.7187 3.507L16.3567 3.75825C16.3756 3.76124 16.3947 3.76274 16.4137 3.76275C16.5089 3.76363 16.6009 3.72829 16.6709 3.66389C16.741 3.59949 16.784 3.51086 16.7911 3.41595C16.7983 3.32105 16.7691 3.22697 16.7095 3.1528C16.6498 3.07862 16.5642 3.0299 16.47 3.0165L9.37499 1.92825V0.75C9.37499 0.650544 9.33549 0.555161 9.26516 0.484835C9.19483 0.414509 9.09945 0.375 8.99999 0.375C8.90054 0.375 8.80515 0.414509 8.73483 0.484835C8.6645 0.555161 8.62499 0.650544 8.62499 0.75V1.8135L1.64324 0.74175C1.54488 0.726732 1.44458 0.751404 1.36441 0.810337C1.28424 0.86927 1.23076 0.957638 1.21574 1.056C1.20073 1.15436 1.2254 1.25466 1.28433 1.33483C1.34326 1.415 1.43163 1.46848 1.52999 1.4835L3.38699 1.76775L0.407244 8.475C0.401869 8.49514 0.398354 8.51572 0.396744 8.5365C0.376216 8.59474 0.376216 8.65826 0.396744 8.7165C0.398721 8.73698 0.402231 8.75729 0.407244 8.77725C0.700588 9.41371 1.17289 9.95099 1.76649 10.3235C2.36009 10.696 3.0493 10.8876 3.74999 10.875C4.45106 10.8876 5.14061 10.6957 5.73438 10.3228C6.32815 9.94982 6.80043 9.41199 7.09349 8.775C7.09851 8.75504 7.10202 8.73473 7.10399 8.71425C7.12452 8.65601 7.12452 8.59249 7.10399 8.53425C7.10238 8.51347 7.09887 8.49289 7.09349 8.47275L4.16849 1.88775L8.62724 2.57175V16.875H4.87724C4.77779 16.875 4.6824 16.9145 4.61208 16.9848C4.54175 17.0552 4.50224 17.1505 4.50224 17.25C4.50224 17.3495 4.54175 17.4448 4.61208 17.5152C4.6824 17.5855 4.77779 17.625 4.87724 17.625H13.1272C13.2267 17.625 13.3221 17.5855 13.3924 17.5152C13.4627 17.4448 13.5022 17.3495 13.5022 17.25C13.5022 17.1505 13.4627 17.0552 13.3924 16.9848C13.3221 16.9145 13.2267 16.875 13.1272 16.875H9.37724V2.6865L13.8427 3.372L10.9095 9.972C10.9041 9.99214 10.9006 10.0127 10.899 10.0335C10.8785 10.0917 10.8785 10.1553 10.899 10.2135C10.901 10.234 10.9045 10.2543 10.9095 10.2743C11.2128 10.9034 11.6874 11.4342 12.2789 11.8056C12.8703 12.1771 13.5546 12.3741 14.253 12.3741C14.9514 12.3741 15.6357 12.1771 16.2271 11.8056C16.8186 11.4342 17.2932 10.9034 17.5965 10.2743C17.6015 10.2543 17.605 10.234 17.607 10.2135C17.6145 10.1846 17.6186 10.1549 17.619 10.125ZM3.74999 10.125C3.29829 10.1316 2.8512 10.0334 2.44378 9.83821C2.03637 9.64302 1.6797 9.35612 1.40174 9H6.09824C5.82029 9.35612 5.46362 9.64302 5.05621 9.83821C4.64879 10.0334 4.2017 10.1316 3.74999 10.125ZM1.32749 8.25L3.74999 2.79825L6.17249 8.25H1.32749ZM14.25 4.29825L16.6725 9.75H11.8275L14.25 4.29825ZM14.25 11.625C13.7983 11.6316 13.3512 11.5334 12.9438 11.3382C12.5364 11.143 12.1797 10.8561 11.9017 10.5H16.5982C16.3203 10.8561 15.9636 11.143 15.5562 11.3382C15.1488 11.5334 14.7017 11.6316 14.25 11.625Z" fill="#8B98A7"/>
                </svg>
              </i>
            </button>
          </div>
          <div class="flat-card__favorite flat-card__favorite--z-0">
            <button class="btn btn_like js-btn_like" data-id="${data.id}">
              <i class="icon icon_like">
                <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8.4 4.73438C5.96995 4.73438 4 7.02994 4 9.86166C4 14.9889 9.2 19.6501 12 20.7344C14.8 19.6501 20 14.9889 20 9.86166C20 7.02994 18.0301 4.73438 15.6 4.73438C14.1119 4.73438 12.7963 5.59524 12 6.91293C11.2037 5.59524 9.88813 4.73438 8.4 4.73438Z" stroke="#8B98A7" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
              </i>
            </button>
          </div>
        </div>
        <div class="flat-card__img flat-card__img--contain flat-card__img--z-0">
        ${picture_2d_layout ?
          `<img class="js-async-image" src="${mini_picture_2d_layout}" data-src="${picture_2d_layout}" alt="layout">`
          : `<img src="${WAY_UP_DEF_IMG}" alt="default">`}
        </div>
        <div class="flat-card-top">
          ${data.rooms_count ? `<div class="flat-card__title">${data.rooms_count}</div>` : ''}
          ${is_with_facing(data.facing) ? `<div class="flat-card__decor">С отделкой</div>` : ''}
        </div>
        ${data.area ? `<div class="flat-card__area">${data.area}</div>` : ''}
        ${data.project_title ?
      `<div class="flat-card-props">
          <div class="flat-card__prop">Проект</div>
          <div class="flat-card__value">${data.project_title}</div>
        </div>` : ''}
        ${data.house ?
      `<div class="flat-card-props">
            <div class="flat-card__prop">Дом</div>
            <div class="flat-card__value">${data.house}</div>
          </div>` : ''}
        ${data.floor_of ?
      `<div class="flat-card-props">
            <div class="flat-card__prop">Этаж</div>
            <div class="flat-card__value">${data.floor_of}</div>
          </div>` : ''}

        <div class="flat-card-bottom">
          ${data.new_price ?
      `<div class="flat-card__price">
            <span class="flat-card_sale">Цена со скидкой *</span>
            <div class="flat-card__price_new">${format_price_intl.format(data.new_price)}</div>
            <div class="flat-card__price_old">${format_price_intl.format(data.price)}</div>
          </div>`
      :
      `<div class="flat-card__price_new"><span>${getPrice(data.price)}</span></div> `}
          ${data.hypotec_from ? `<div class="flat-card-mortgage">В ипотеку <br> ${data.hypotec_from}</div>` : ""}
        </div>
      </div>

      ${data.new_price
        ? `<div class="flat-card_sale">
            * Скидки предоставляются в соответствии с разделом
            <a href="${promo_url}" class="flat-card_sale-link">Акции</a>
          </div>`
        : ''  
      }

      <div class="icon icon_lg flat-card__blocked flat-card__blocked--z-0">
        <div class="flat-card__blocked__icon js-card-blocked">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="4" y="11" width="16" height="10" rx="2" stroke="white" stroke-width="1.3" stroke-linejoin="round"></rect>
            <path d="M7 11V7.44444C7 4.98985 9.23858 3 12 3C14.7614 3 17 4.98985 17 7.44444V11" stroke="white" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path>
            <path d="M12 15V17" stroke="white" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path>
          </svg>
        </div>
      </div>
    </div>`
}
export const get_template_card_townhouse_tiles_notype = (data) => {
  const picture_2d_layout = data.picture_simple_2d ?? data.get_picture_2d
  const mini_picture_2d_layout = data.mini_picture_simple_2d ?? data.mini_picture_2d
  return `
    <div class="card flat-card ${data.status_property === "BOOKED" ? `card-blocked` : ''}">
      <div class="objects-table-link">
        <a class="" href="${data.absolute_url}" target="_blank"></a>
      </div>

      <div class="card">
        <div class="flat-card__favorite flat-card__favorite--z-0">
          <a class="btn btn_like js-btn_like" data-id="${data.id}">
            <i class="icon icon_like">
              <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8.4 4.73438C5.96995 4.73438 4 7.02994 4 9.86166C4 14.9889 9.2 19.6501 12 20.7344C14.8 19.6501 20 14.9889 20 9.86166C20 7.02994 18.0301 4.73438 15.6 4.73438C14.1119 4.73438 12.7963 5.59524 12 6.91293C11.2037 5.59524 9.88813 4.73438 8.4 4.73438Z" stroke="#8B98A7" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path>
              </svg>
            </i>
          </a>
        </div>
        <div class="flat-card__img flat-card__img--contain flat-card__img--z-0">
        ${picture_2d_layout ?
          `<img class="js-async-image" src="${mini_picture_2d_layout}" data-src="${picture_2d_layout}" alt="layout">`
          : `<img src="${WAY_UP_DEF_IMG}" alt="default">`}
          </div>
          <div class="flat-card-top">
            <div class="flat-card__title">Квартира в таунхаусе ${data.number  ? `№ ${data.number}`: ''} </div>
            ${is_with_facing(data.facing) ? `<div class="flat-card__decor">С отделкой</div>` : ''}
          </div>
          <div class="flat-card__props-area">
            ${data.area ? `<div class="flat-card__prop"> Площадь дома: <span class="flat-card__area flat-card__props-area__value">${data.area}</span></div>` : ''}
            ${data.area_district ? `<div class="flat-card__prop">Участка: <span class="flat-card__area flat-card__props-area__value">${data.area_district} сот.</span></div>` : ''}
          </div>
          ${data.project_title ?
      `<div class="flat-card-props">
              <div class="flat-card__prop">Проект</div>
              <div class="flat-card__value">${data.project_title}</div>
            </div>` : ''}
          ${data.queue ?
      `<div class="flat-card-props">
            <div class="flat-card__prop">Очередь строительства</div>
            <div class="flat-card__value">${data.queue}</div>
          </div>` : ''}
          ${data.house ?
      `<div class="flat-card-props">
            <div class="flat-card__prop">Дом</div>
            <div class="flat-card__value">${data.house}</div>
          </div>` : ''}
          <div class="flat-card-bottom">
          ${data.new_price ?
      `<div class="flat-card__price">
            <span class="flat-card_sale">Цена со скидкой *</span>
            <div class="flat-card__price_new"><span>${format_price_intl.format(data.new_price)} </span></div>
            <div class="flat-card__price_old"><span>${format_price_intl.format(data.price)}  </span></div>
          </div>`
      :
      `<div class="flat-card__price_new"><span>${getPrice(data.price)}</span></div> `}
          ${data.hypotec_from ? `<div class="flat-card-mortgage">В ипотеку <br> ${data.hypotec_from}</div>` : ""}
          </div>
      </div>

      ${data.new_price
        ? `<div class="flat-card_sale">
            * Скидки предоставляются в соответствии с разделом
            <a href="${promo_url}" class="flat-card_sale-link">Акции</a>
          </div>`
        : ''
      }

      <div class="icon icon_lg flat-card__blocked flat-card__blocked--z-0">
        <div class="flat-card__blocked__icon js-townhouse-card-blocked">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="4" y="11" width="16" height="10" rx="2" stroke="white" stroke-width="1.3" stroke-linejoin="round"></rect>
            <path d="M7 11V7.44444C7 4.98985 9.23858 3 12 3C14.7614 3 17 4.98985 17 7.44444V11" stroke="white" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path>
            <path d="M12 15V17" stroke="white" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path>
          </svg>
        </div>
      </div>
    </div>`
}
export const get_template_card_office_tiles_notype = (data) => {
  const picture_2d_layout = data.picture_simple_2d ?? data.get_picture_2d
  const mini_picture_2d_layout = data.mini_picture_simple_2d ?? data.mini_picture_2d
  return `
    <div class="card flat-card ${data.status === "BOOKED" ? `card-blocked` : ''}">
      <div class="objects-table-link">
        <a class="" href="${data.absolute_url}" target="_blank"></a>
      </div>

      <div class="card">
        <div class="flat-card__favorite flat-card__favorite--z-0">
          <button class="btn btn_like js-btn_like" data-id="${data.id}">
            <i class="icon icon_like">
              <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8.4 4.73438C5.96995 4.73438 4 7.02994 4 9.86166C4 14.9889 9.2 19.6501 12 20.7344C14.8 19.6501 20 14.9889 20 9.86166C20 7.02994 18.0301 4.73438 15.6 4.73438C14.1119 4.73438 12.7963 5.59524 12 6.91293C11.2037 5.59524 9.88813 4.73438 8.4 4.73438Z" stroke="#8B98A7" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path>
              </svg>
            </i>
          </button>
        </div>
        <div class="flat-card__img flat-card__img--contain flat-card__img--z-0">
          ${picture_2d_layout ?
            `<img class="js-async-image" src="${mini_picture_2d_layout}" data-src="${picture_2d_layout}" alt="layout">`
            : `<img src="${WAY_UP_DEF_IMG}" alt="default">`}
          </div>
          <div class="flat-card-top">
            <div class="flat-card__title">Офис</div>
          </div>
          ${data.number ? `<div class="flat-card__title">№ ${data.number}</div>` : ''}
          <div class="flat-card__props-area">
            ${data.area ? `<div class="flat-card__prop"><span class="flat-card__area flat-card__props-area__value">${data.area}</span></div>` : ''}
          </div>

          ${data.project_title ?
      `<div class="flat-card-props">
            <div class="flat-card__prop">Проект</div>
            <div class="flat-card__value">${data.project_title}</div>
          </div>` : ''}

          ${data.house ?
      `<div class="flat-card-props">
            <div class="flat-card__prop">Дом</div>
            <div class="flat-card__value">${data.house}</div>
          </div>` : ''}
        ${data.floor_of ?
      `<div class="flat-card-props">
              <div class="flat-card__prop">Этаж</div>
              <div class="flat-card__value">${data.floor_of}</div>
            </div>` : ''}
        <div class="flat-card-bottom">
        ${data.new_price ?
      `<div class="flat-card__price">
          <span class="flat-card_sale">Цена со скидкой *</span>
          <div class="flat-card__price_new"><span> ${format_price_intl.format(data.new_price)} </span></div>
          <div class="flat-card__price_old"><span>${format_price_intl.format(data.price)} </span></div>
        </div>`
      :
      `<div class="flat-card__price_new"><span>${getPrice(data.price)} </span></div> `}
        ${data.hypotec_from ? `<div class="flat-card-mortgage">В ипотеку <br> ${data.hypotec_from}</div>` : ''}
        </div>
      </div>

      ${data.new_price
        ? `<div class="flat-card_sale">
            * Скидки предоставляются в соответствии с разделом
            <a href="${promo_url}" class="flat-card_sale-link">Акции</a>
          </div>`
        : ''
      }

      <div class="icon icon_lg flat-card__blocked flat-card__blocked--z-0">
        <div class="flat-card__blocked__icon js-office-card-blocked">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="4" y="11" width="16" height="10" rx="2" stroke="white" stroke-width="1.3" stroke-linejoin="round"></rect>
            <path d="M7 11V7.44444C7 4.98985 9.23858 3 12 3C14.7614 3 17 4.98985 17 7.44444V11" stroke="white" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path>
            <path d="M12 15V17" stroke="white" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path>
          </svg>
        </div>
      </div>
    </div>`
}

export const get_template_card_object_table_notype = (data) => {
  const picture_2d_layout = data.picture_simple_2d ?? data.get_picture_2d
  const mini_picture_2d_layout = data.mini_picture_simple_2d ?? data.mini_picture_2d
  return `
    <div class="objects-card ${data.status === "BOOKED" ? `card-blocked` : ''}">
      <div class="objects-table-link">
        <a class="" href="${data.absolute_url}" target="_blank"></a>
      </div>

    <div class="objects-table-top objects-table-item">
      <div class="object-card__img js-card__img flat-card__img--contain flat-card__img--z-0"><i class="icon icon_lg"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18Z" stroke="#59B039" stroke-width="1.3" stroke-linejoin="round"></path>
        <path d="M16.0748 16.0746L20.8242 20.8241" stroke="#59B039" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path>
        <path d="M10 6V14" stroke="#59B039" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path>
        <path d="M6 10H14" stroke="#59B039" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path>
        </svg></i>
        ${picture_2d_layout ?
          `<img class="js-async-image" src="${mini_picture_2d_layout}" data-src="${picture_2d_layout}" alt="layout">`
          : `<img src="${WAY_UP_DEF_IMG}" alt="default">`}
        </div>
      <div class="object-card__name">
      ${data.rooms_count ? `<div class="object-card__title">${data.rooms_count}</div>` : '<div></div>'}
        ${is_with_facing(data.facing) ? `<div class="flat-card__decor">С отделкой</div>` : ''}
      </div>
      ${data.area ? `<div class="object-card__area">${data.area}</div>` : '<div></div>'}
      ${data.floor_of ? `<div class="object-card__floor">${data.floor_of}</div>` : '<div></div>'}
      ${data.number ? `<div class="object-card__number">${data.number}</div>` : '<div></div>'}
      ${data.project_title ? `<div class="object-card__project">${data.project_title}</div>` : '<div></div>'}
      ${data.house ? `<div class="object-card__address">${data.house}</div>` : '<div></div>'}
      ${data.development_quarter ? `<div class="object-card__deadline">${data.development_quarter}</div>` : '<div></div>'}
      ${data.new_price ?
      `<div class="flat-card__price">
          <span class="flat-card_sale">Цена со скидкой *</span>
          <div class="flat-card__price_new">${format_price_intl.format(data.new_price)}</div>
          <div class="flat-card__price_old">${format_price_intl.format(data.price)}</div>
        </div>`
      :
      `<div class="flat-card__price">
            <div class="flat-card__price_new">${getPrice(data.price)}</div>
          </div>`}
        <div class="flat-card__comparison flat-card__comparison--z-0">
          <button class="btn btn_comparison js-btn_comparison" data-id="${data.id}">
            <i class="icon icon_comparison">
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M17.619 10.125C17.6174 10.0945 17.6121 10.0642 17.6032 10.035C17.6016 10.0142 17.5981 9.99364 17.5927 9.9735L14.7187 3.507L16.3567 3.75825C16.3756 3.76124 16.3947 3.76274 16.4137 3.76275C16.5089 3.76363 16.6009 3.72829 16.6709 3.66389C16.741 3.59949 16.784 3.51086 16.7911 3.41595C16.7983 3.32105 16.7691 3.22697 16.7095 3.1528C16.6498 3.07862 16.5642 3.0299 16.47 3.0165L9.37499 1.92825V0.75C9.37499 0.650544 9.33549 0.555161 9.26516 0.484835C9.19483 0.414509 9.09945 0.375 8.99999 0.375C8.90054 0.375 8.80515 0.414509 8.73483 0.484835C8.6645 0.555161 8.62499 0.650544 8.62499 0.75V1.8135L1.64324 0.74175C1.54488 0.726732 1.44458 0.751404 1.36441 0.810337C1.28424 0.86927 1.23076 0.957638 1.21574 1.056C1.20073 1.15436 1.2254 1.25466 1.28433 1.33483C1.34326 1.415 1.43163 1.46848 1.52999 1.4835L3.38699 1.76775L0.407244 8.475C0.401869 8.49514 0.398354 8.51572 0.396744 8.5365C0.376216 8.59474 0.376216 8.65826 0.396744 8.7165C0.398721 8.73698 0.402231 8.75729 0.407244 8.77725C0.700588 9.41371 1.17289 9.95099 1.76649 10.3235C2.36009 10.696 3.0493 10.8876 3.74999 10.875C4.45106 10.8876 5.14061 10.6957 5.73438 10.3228C6.32815 9.94982 6.80043 9.41199 7.09349 8.775C7.09851 8.75504 7.10202 8.73473 7.10399 8.71425C7.12452 8.65601 7.12452 8.59249 7.10399 8.53425C7.10238 8.51347 7.09887 8.49289 7.09349 8.47275L4.16849 1.88775L8.62724 2.57175V16.875H4.87724C4.77779 16.875 4.6824 16.9145 4.61208 16.9848C4.54175 17.0552 4.50224 17.1505 4.50224 17.25C4.50224 17.3495 4.54175 17.4448 4.61208 17.5152C4.6824 17.5855 4.77779 17.625 4.87724 17.625H13.1272C13.2267 17.625 13.3221 17.5855 13.3924 17.5152C13.4627 17.4448 13.5022 17.3495 13.5022 17.25C13.5022 17.1505 13.4627 17.0552 13.3924 16.9848C13.3221 16.9145 13.2267 16.875 13.1272 16.875H9.37724V2.6865L13.8427 3.372L10.9095 9.972C10.9041 9.99214 10.9006 10.0127 10.899 10.0335C10.8785 10.0917 10.8785 10.1553 10.899 10.2135C10.901 10.234 10.9045 10.2543 10.9095 10.2743C11.2128 10.9034 11.6874 11.4342 12.2789 11.8056C12.8703 12.1771 13.5546 12.3741 14.253 12.3741C14.9514 12.3741 15.6357 12.1771 16.2271 11.8056C16.8186 11.4342 17.2932 10.9034 17.5965 10.2743C17.6015 10.2543 17.605 10.234 17.607 10.2135C17.6145 10.1846 17.6186 10.1549 17.619 10.125ZM3.74999 10.125C3.29829 10.1316 2.8512 10.0334 2.44378 9.83821C2.03637 9.64302 1.6797 9.35612 1.40174 9H6.09824C5.82029 9.35612 5.46362 9.64302 5.05621 9.83821C4.64879 10.0334 4.2017 10.1316 3.74999 10.125ZM1.32749 8.25L3.74999 2.79825L6.17249 8.25H1.32749ZM14.25 4.29825L16.6725 9.75H11.8275L14.25 4.29825ZM14.25 11.625C13.7983 11.6316 13.3512 11.5334 12.9438 11.3382C12.5364 11.143 12.1797 10.8561 11.9017 10.5H16.5982C16.3203 10.8561 15.9636 11.143 15.5562 11.3382C15.1488 11.5334 14.7017 11.6316 14.25 11.625Z" fill="#8B98A7"/>
              </svg>
            </i>
          </button>
        </div>
        <div class="wrap_btn_like">
          <button class="btn btn_like js-btn_like flat-card__favorite--z-0" data-id="${data.id}">
            <i class="icon icon_like">
              <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8.4 4.73438C5.96995 4.73438 4 7.02994 4 9.86166C4 14.9889 9.2 19.6501 12 20.7344C14.8 19.6501 20 14.9889 20 9.86166C20 7.02994 18.0301 4.73438 15.6 4.73438C14.1119 4.73438 12.7963 5.59524 12 6.91293C11.2037 5.59524 9.88813 4.73438 8.4 4.73438Z" stroke="#8B98A7" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path>
              </svg>
            </i>
          </button>
        </div>
      </div>

    <div class="objects-card__blocked flat-card__blocked--z-0">
        <div class="objects-card__blocked__icon js-card-blocked">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="4" y="11" width="16" height="10" rx="2" stroke="white" stroke-width="1.3" stroke-linejoin="round"></rect>
            <path d="M7 11V7.44444C7 4.98985 9.23858 3 12 3C14.7614 3 17 4.98985 17 7.44444V11" stroke="white" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path>
            <path d="M12 15V17" stroke="white" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path>
          </svg>
        </div>
      </div>
  </div>`
}
export const get_template_card_object_table_notype_short = (data) => {
  const picture_2d_layout = data.picture_simple_2d ?? data.get_picture_2d
  const mini_picture_2d_layout = data.mini_picture_simple_2d ?? data.mini_picture_2d
  return `
    <div class="objects-card ${data.status === "BOOKED" ? `card-blocked` : ''}">
      <div class="objects-table-link">
        <a class="" href="${data.absolute_url}" target="_blank"></a>
      </div>

    <div class="objects-table-top objects-table-top--catalog objects-table-item">
      <div class="object-card__img js-card__img flat-card__img--contain flat-card__img--z-0"><i class="icon icon_lg"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18Z" stroke="#59B039" stroke-width="1.3" stroke-linejoin="round"></path>
        <path d="M16.0748 16.0746L20.8242 20.8241" stroke="#59B039" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path>
        <path d="M10 6V14" stroke="#59B039" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path>
        <path d="M6 10H14" stroke="#59B039" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path>
        </svg></i>
        ${picture_2d_layout ?
          `<img class="js-async-image" src="${mini_picture_2d_layout}" data-src="${picture_2d_layout}" alt="layout">`
          : `<img src="${WAY_UP_DEF_IMG}" alt="default">`}
        </div>
      <div class="object-card__name">
      ${data.rooms_count ? `<div class="object-card__title">${data.rooms_count}</div>` : '<div></div>'}
        ${is_with_facing(data.facing) ? `<div class="flat-card__decor">С отделкой</div>` : ''}
      </div>
      ${data.area ? `<div class="object-card__area">${data.area}</div>` : '<div></div>'}
      ${data.floor_of ? `<div class="object-card__floor">${data.floor_of}</div>` : '<div></div>'}
      ${data.number ? `<div class="object-card__number">${data.number}</div>` : '<div></div>'}
      ${data.new_price ?
      `<div class="flat-card__price">
          <span class="flat-card_sale">Цена со скидкой *</span>
          <div class="flat-card__price_new">${format_price_intl.format(data.new_price)}</div>
          <div class="flat-card__price_old">${format_price_intl.format(data.price)}</div>
        </div>`
      :
      `<div class="flat-card__price">
            <div class="flat-card__price_new">${getPrice(data.price)}</div>
          </div`}
        <div class="wrap_btn_like">
        <button class="btn btn_comparison js-btn_comparison flat-card__comparison--z-0" data-id="${data.id}">
          <i class="icon icon_comparison">
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M17.619 10.125C17.6174 10.0945 17.6121 10.0642 17.6032 10.035C17.6016 10.0142 17.5981 9.99364 17.5927 9.9735L14.7187 3.507L16.3567 3.75825C16.3756 3.76124 16.3947 3.76274 16.4137 3.76275C16.5089 3.76363 16.6009 3.72829 16.6709 3.66389C16.741 3.59949 16.784 3.51086 16.7911 3.41595C16.7983 3.32105 16.7691 3.22697 16.7095 3.1528C16.6498 3.07862 16.5642 3.0299 16.47 3.0165L9.37499 1.92825V0.75C9.37499 0.650544 9.33549 0.555161 9.26516 0.484835C9.19483 0.414509 9.09945 0.375 8.99999 0.375C8.90054 0.375 8.80515 0.414509 8.73483 0.484835C8.6645 0.555161 8.62499 0.650544 8.62499 0.75V1.8135L1.64324 0.74175C1.54488 0.726732 1.44458 0.751404 1.36441 0.810337C1.28424 0.86927 1.23076 0.957638 1.21574 1.056C1.20073 1.15436 1.2254 1.25466 1.28433 1.33483C1.34326 1.415 1.43163 1.46848 1.52999 1.4835L3.38699 1.76775L0.407244 8.475C0.401869 8.49514 0.398354 8.51572 0.396744 8.5365C0.376216 8.59474 0.376216 8.65826 0.396744 8.7165C0.398721 8.73698 0.402231 8.75729 0.407244 8.77725C0.700588 9.41371 1.17289 9.95099 1.76649 10.3235C2.36009 10.696 3.0493 10.8876 3.74999 10.875C4.45106 10.8876 5.14061 10.6957 5.73438 10.3228C6.32815 9.94982 6.80043 9.41199 7.09349 8.775C7.09851 8.75504 7.10202 8.73473 7.10399 8.71425C7.12452 8.65601 7.12452 8.59249 7.10399 8.53425C7.10238 8.51347 7.09887 8.49289 7.09349 8.47275L4.16849 1.88775L8.62724 2.57175V16.875H4.87724C4.77779 16.875 4.6824 16.9145 4.61208 16.9848C4.54175 17.0552 4.50224 17.1505 4.50224 17.25C4.50224 17.3495 4.54175 17.4448 4.61208 17.5152C4.6824 17.5855 4.77779 17.625 4.87724 17.625H13.1272C13.2267 17.625 13.3221 17.5855 13.3924 17.5152C13.4627 17.4448 13.5022 17.3495 13.5022 17.25C13.5022 17.1505 13.4627 17.0552 13.3924 16.9848C13.3221 16.9145 13.2267 16.875 13.1272 16.875H9.37724V2.6865L13.8427 3.372L10.9095 9.972C10.9041 9.99214 10.9006 10.0127 10.899 10.0335C10.8785 10.0917 10.8785 10.1553 10.899 10.2135C10.901 10.234 10.9045 10.2543 10.9095 10.2743C11.2128 10.9034 11.6874 11.4342 12.2789 11.8056C12.8703 12.1771 13.5546 12.3741 14.253 12.3741C14.9514 12.3741 15.6357 12.1771 16.2271 11.8056C16.8186 11.4342 17.2932 10.9034 17.5965 10.2743C17.6015 10.2543 17.605 10.234 17.607 10.2135C17.6145 10.1846 17.6186 10.1549 17.619 10.125ZM3.74999 10.125C3.29829 10.1316 2.8512 10.0334 2.44378 9.83821C2.03637 9.64302 1.6797 9.35612 1.40174 9H6.09824C5.82029 9.35612 5.46362 9.64302 5.05621 9.83821C4.64879 10.0334 4.2017 10.1316 3.74999 10.125ZM1.32749 8.25L3.74999 2.79825L6.17249 8.25H1.32749ZM14.25 4.29825L16.6725 9.75H11.8275L14.25 4.29825ZM14.25 11.625C13.7983 11.6316 13.3512 11.5334 12.9438 11.3382C12.5364 11.143 12.1797 10.8561 11.9017 10.5H16.5982C16.3203 10.8561 15.9636 11.143 15.5562 11.3382C15.1488 11.5334 14.7017 11.6316 14.25 11.625Z" fill="#8B98A7"/>
            </svg>
          </i>
        </button>
        <button class="btn btn_like js-btn_like flat-card__favorite--z-0" data-id="${data.id}">
          <i class="icon icon_like">
            <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8.4 4.73438C5.96995 4.73438 4 7.02994 4 9.86166C4 14.9889 9.2 19.6501 12 20.7344C14.8 19.6501 20 14.9889 20 9.86166C20 7.02994 18.0301 4.73438 15.6 4.73438C14.1119 4.73438 12.7963 5.59524 12 6.91293C11.2037 5.59524 9.88813 4.73438 8.4 4.73438Z" stroke="#8B98A7" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
          </i>
        </button>
      </div>

    <div class="objects-card__blocked flat-card__blocked--z-0">
        <div class="objects-card__blocked__icon js-card-blocked">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="4" y="11" width="16" height="10" rx="2" stroke="white" stroke-width="1.3" stroke-linejoin="round"></rect>
            <path d="M7 11V7.44444C7 4.98985 9.23858 3 12 3C14.7614 3 17 4.98985 17 7.44444V11" stroke="white" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path>
            <path d="M12 15V17" stroke="white" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path>
          </svg>
        </div>
      </div>
  </div>`;
};
export const get_template_card_townhouse_table_notype = (data) => {
  const picture_2d_layout = data.picture_simple_2d ?? data.get_picture_2d
  const mini_picture_2d_layout = data.mini_picture_simple_2d ?? data.mini_picture_2d
  return `
    <div class="objects-card ${data.status_property === "BOOKED" ? `card-blocked` : ''} ">
      <div class="objects-table-link">
        <a class="" href="${data.absolute_url}" target="_blank"></a>
      </div>
      <div class="object-card townhouse-table-top">
        <div class="object-card__img js-card__img flat-card__img--contain flat-card__img--z-0"><i class="icon icon_lg"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18Z" stroke="#59B039" stroke-width="1.3" stroke-linejoin="round"></path>
          <path d="M16.0748 16.0746L20.8242 20.8241" stroke="#59B039" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path>
          <path d="M10 6V14" stroke="#59B039" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path>
          <path d="M6 10H14" stroke="#59B039" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path>
          </svg></i>
          ${picture_2d_layout ?
            `<img class="js-async-image" src="${mini_picture_2d_layout}" data-src="${picture_2d_layout}" alt="layout">`
            : `<img src="${WAY_UP_DEF_IMG}" alt="default">`}
          </div>
        <div class="object-card__name">
          ${data.number ? ` <div class="object-card__number">№ ${data.number}</div>` : ''}
          <div class="object-card__title">Квартира в таунхаусе ${data.number  ? `№ ${data.number}`: ''}</div>
           ${is_with_facing(data.facing) ? `<div class="flat-card__decor">С отделкой</div>` : ''}
        </div>
        ${data.area ? `<div class="object-card__area">${data.area}</div>` : '<div></div>'}
        ${data.area_district ? `<div class="object-card__plot">${data.area_district}</div>` : '<div></div>'}
        ${data.development_quarter ? `<div class="object-card__deadline">${data.development_quarter}</div>` : '<div></div>'}
        ${data.project_title ? `<div class="object-card__project">${data.project_title}</div>` : '<div></div>'}
        ${data.queue ? `<div class="object-card__queue">${data.queue}</div>` : '<div></div>'}
        ${data.house ? `<div class="object-card__address">${data.house}</div>` : '<div></div>'}
        ${data.new_price ?
      `<div class="flat-card__price">
                <span class="flat-card_sale">Цена со скидкой *</span>
                <div class="flat-card__price_new">${format_price_intl.format(data.new_price)}</div>
                <div class="flat-card__price_old">${format_price_intl.format(data.price)}</div>
              </div>`
      :
      `<div class="flat-card__price">
                  <div class="flat-card__price_new">${getPrice(data.price)}</div>
                </div`}
        <div class="wrap_btn_like">
        <button class="btn btn_like js-btn_like flat-card__favorite--z-0" data-id="${data.id}">
          <i class="icon icon_like">
            <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8.4 4.73438C5.96995 4.73438 4 7.02994 4 9.86166C4 14.9889 9.2 19.6501 12 20.7344C14.8 19.6501 20 14.9889 20 9.86166C20 7.02994 18.0301 4.73438 15.6 4.73438C14.1119 4.73438 12.7963 5.59524 12 6.91293C11.2037 5.59524 9.88813 4.73438 8.4 4.73438Z" stroke="#8B98A7" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
          </i>
        </button>
        </div>
      <div class="objects-card__blocked flat-card__blocked--z-0">
        <div class="objects-card__blocked__icon js-townhouse-card-blocked">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="4" y="11" width="16" height="10" rx="2" stroke="white" stroke-width="1.3" stroke-linejoin="round"></rect>
            <path d="M7 11V7.44444C7 4.98985 9.23858 3 12 3C14.7614 3 17 4.98985 17 7.44444V11" stroke="white" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path>
            <path d="M12 15V17" stroke="white" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path>
          </svg>
        </div>
      </div>
    </div>`
}
export const get_template_card_office_table_notype = (data) => {
  const picture_2d_layout = data.picture_simple_2d ?? data.get_picture_2d
  const mini_picture_2d_layout = data.mini_picture_simple_2d ?? data.mini_picture_2d
  return `
    <div class="objects-card ${data.status === "BOOKED" ? `card-blocked` : ''} ">
        <div class="objects-table-link">
          <a class="" href="${data.absolute_url}" target="_blank"></a>
        </div>
        <div class="object-card commercial-table-top">
          <div class="object-card__img js-card__img flat-card__img--contain flat-card__img--z-0"><i class="icon icon_lg"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18Z" stroke="#59B039" stroke-width="1.3" stroke-linejoin="round"></path>
            <path d="M16.0748 16.0746L20.8242 20.8241" stroke="#59B039" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path>
            <path d="M10 6V14" stroke="#59B039" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path>
            <path d="M6 10H14" stroke="#59B039" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg></i>
            ${picture_2d_layout ?
              `<img class="js-async-image" src="${mini_picture_2d_layout}" data-src="${picture_2d_layout}" alt="layout">`
              : `<img src="${WAY_UP_DEF_IMG}" alt="default">`}
          </div>
          <div class="object-card__name">
            ${data.number ? `<div class="object-card__number">№${data.number}</div>` : ''}
            <div class="object-card__title">Офис</div>
          </div>
          ${data.area ? `<div class="object-card__area">${data.area}</div>` : '<div></div>'}
          ${data.project_title ? `<div class="object-card__project">${data.project_title}</div>` : '<div></div>'}
          ${data.house ? `<div class="object-card__address">${data.house}</div>` : '<div></div>'}
          ${data.development_quarter ? `<div class="object-card__deadline">${data.development_quarter}</div>` : '<div></div>'}
          ${data.new_price ?
      `<div class="flat-card__price">
            <span class="flat-card_sale">Цена со скидкой *</span>
            <div class="flat-card__price_new">${format_price_intl.format(data.new_price)}</div>
            <div class="flat-card__price_old">${format_price_intl.format(data.price)}</div>
          </div>`:
      `<div class="flat-card__price">
            <div class="flat-card__price_new">${getPrice(data.price)}</div>
          </div`}
          <div class="wrap_btn_like">
            <button class="btn btn_like js-btn_like flat-card__favorite--z-0" data-id="${data.id}">
              <i class="icon icon_like">
                <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8.4 4.73438C5.96995 4.73438 4 7.02994 4 9.86166C4 14.9889 9.2 19.6501 12 20.7344C14.8 19.6501 20 14.9889 20 9.86166C20 7.02994 18.0301 4.73438 15.6 4.73438C14.1119 4.73438 12.7963 5.59524 12 6.91293C11.2037 5.59524 9.88813 4.73438 8.4 4.73438Z" stroke="#8B98A7" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
              </i>
            </button>
          </div>
        <div class="objects-card__blocked flat-card__blocked--z-0">
          <div class="objects-card__blocked__icon js-office-card-blocked">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="4" y="11" width="16" height="10" rx="2" stroke="white" stroke-width="1.3" stroke-linejoin="round"></rect>
              <path d="M7 11V7.44444C7 4.98985 9.23858 3 12 3C14.7614 3 17 4.98985 17 7.44444V11" stroke="white" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path>
              <path d="M12 15V17" stroke="white" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
          </div>
        </div>
    </div>`
}

export const get_template_card_object_table_type = (data) => {
  const picture_2d_layout = data.picture_simple_2d ?? data.picture_2d
  const mini_picture_2d_layout = data.mini_picture_simple_2d ?? data.mini_picture_2d
  return `
    <div class="object-card objects-table-top-type">
      <div class="object-card__img js-card__img flat-card__img--contain"><i class="icon icon_lg"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18Z" stroke="#59B039" stroke-width="1.3" stroke-linejoin="round"></path>
          <path d="M16.0748 16.0746L20.8242 20.8241" stroke="#59B039" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path>
          <path d="M10 6V14" stroke="#59B039" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path>
          <path d="M6 10H14" stroke="#59B039" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path>
          </svg></i>
          ${picture_2d_layout ?
            `<img class="js-async-image" src="${mini_picture_2d_layout}" data-src="${picture_2d_layout}" alt="layout">`
            : `<img src="${WAY_UP_DEF_IMG}" alt="default">`}
          </div>
          ${data.name ? `<div class="object-card__type">${data.name}</div>` : '<div></div>'}
      <div class="object-card__name">
        ${data.rooms ? `<div class="object-card__title">${data.rooms}</div>` : "<div></div>"}
        ${is_with_facing(data.facing) ? `<div class="flat-card__decor">С отделкой</div>` : ''}
      </div>
      ${data.area ? `<div class="object-card__area">${data.area[0] === data.area[1] ? data.area[0] : `${data.area[0]} - ${data.area[1]}`} м²</div>` : '<div></div>'}
      ${data.floors ? `<div class="object-card__floor">${data.floors}</div>` : '<div></div>'}
      ${data.project ? `<div class="object-card__project">${data.project}</div>` : '<div></div>'}
      ${data.house ? `<div class="object-card__address">${data.house}</div>` : '<div></div>'}
      ${data.new_price ?
      `<div class="flat-card__price">
          <span class="flat-card_sale">Цена со скидкой *</span>
          <div class="flat-card__price_new">${format_price_intl.format(data.new_price)}</div>
          <div class="flat-card__price_old">${format_price_intl.format(data.price)}</div>
        </div>`
      :
      `<div class="flat-card__price">
          <div class="flat-card__price_new">${getPrice(data.price)}</div>
        </div>`}
      <p class="object-card__rooms cursor link-info-block js-link-info-block" data-id="${data.id}">
       ${conjugation(data.count, ['квартира', 'квартиры', 'квартир'])}
      </p>
    </div>`
}
export const get_template_card_object_tiles_type = (data) => {
  const picture_2d_layout = data.picture_simple_2d ?? data.picture_2d
  const mini_picture_2d_layout = data.mini_picture_simple_2d ?? data.mini_picture_2d
  return `
    <div class="flat-stack">
      <div class="flat-card flat-card-header flat-card-type card cursor js-link-info-block" data-id="${data.id}">
        <div class=''>
          ${data.name ? `<div class="flat-card__type">${data.name}</div>` : ''}
          <div class="flat-card__img flat-card__img--contain">
          ${picture_2d_layout ?
            `<img class="js-async-image" src="${mini_picture_2d_layout}" data-src="${picture_2d_layout}" alt="layout">`
            : `<img src="${WAY_UP_DEF_IMG}" alt="default">`}
          </div>
          <div class="flat-card-top">
            <div class="flat-card__title">${data.rooms}</div>
            ${is_with_facing(data.facing) ? `<div class="flat-card__decor">С отделкой</div>` : ''}
          </div>
          <div class="flat-card__area">${data.area[0] === data.area[1] ? data.area[0] : `${data.area[0]} - ${data.area[1]}`} м²</div>
          ${data.project ?
      `<div class="flat-card-props">
            <div class="flat-card__prop">Проект</div>
            <div class="flat-card__value">${data.project}</div>
          </div>`
      : '<div class="flat-card-props"> <div class="flat-card__prop">Проект</div><div class="flat-card__value">-</div></div>'}
          ${data.house ?
      `<div class="flat-card-props">
            <div class="flat-card__prop">Дом</div>
            <div class="flat-card__value">${data.house}</div>
          </div>`
      : ''}
          ${data.floors ?
      `<div class="flat-card-props">
            <div class="flat-card__prop">Этаж</div>
            <div class="flat-card__value">${data.floors}</div>
          </div>`
      : ''}
          <div class="flat-card-bottom">
            ${data.new_price ?
      `<div class="flat-card__price">
              <span class="flat-card_sale">Цена со скидкой *</span>
              <div class="flat-card__price_new">${format_price_intl.format(data.new_price)}</div>
              <div class="flat-card__price_old">${format_price_intl.format(data.price)}</div>
            </div>`:
      `<div class="flat-card__price">
              <div class="flat-card__price_new">${getPrice(data.price)}</div>
            </div>`}
            ${data.hypothec_from ?
      `<div class="flat-card-mortgage">В ипотеку <br> ${data.hypothec_from}</div>`
      : ''}
          </div>

          ${data.new_price ? 
            `<div class="flat-card_sale">
              * Скидки предоставляются в соответствии с разделом
              <a href="${promo_url}" class="flat-card_sale-link">Акции</a>
            </div>`
            : ''
          }

        </div>
        <div class="flat-card-count link-info-block">${conjugation(data.count, ['квартира', 'квартиры', 'квартир'])} </div>
      </div>
    </div>`
}

export const get_template_card_detail = (data) => {
  const development_quarter = data?.properties?.results?.[0]?.development_quarter;
  return `
  <div class="type-card">
    <div class="project-hidden">
      <input class='js-detail-catalog-id' type="text" name="id" value="${data.id}">
    </div>
    ${data.picture_2d ?
      `<img src="${data.picture_2d}" alt="Планировка">`
      : `<img src="${WAY_UP_DEF_IMG}" alt="default">`}
    <div class="type-card__title">
        <span>${data.rooms}</span>
        ${is_with_facing(data.facing) ? `<div class="flat-card__decor">С отделкой</div>` : ''}
    </div>
    <div class="type-card__row">
        <div class="type-card__text">Площадь</div>
        <div class="type-card__area">${data.area[0] === data.area[1] ? data.area[0] : `${data.area[0]} - ${data.area[1]}`} м²</div>
    </div>
    ${data.project ?
    `<div class="type-card__row">
        <div class="type-card__text">Проект</div>
        <div class="type-card__project">${data.project}</div>
    </div>` : ''}
    <div class="type-card__row">
        <div class="type-card__text">Дом</div>
        <div class="type-card__house">${data.house}</div>
    </div>
    <div class="type-card__row">
        <div class="type-card__text">Этаж</div>
        <div class="type-card__floor">${data.floors}</div>
    </div>
    ${development_quarter?
    `<div class="type-card__row">
        <div class="type-card__text">Срок сдачи</div>
        <div class="type-card__floor">${development_quarter}</div>
    </div>`:''}
    <div class="type-card-bottom">
      ${data.price ? `<div class="flat-card__price_new"><span>${getPrice(data.price)}</span></div>` : ""}
      ${data.hypotec_from ? `<div class="flat-card-mortgage"> В ипотеку <br> ${data.hypotec_from}</div>` : ""}
    </div>
    <p class="type-card-similar">
      ${conjugation(data.count, ['похожая квартира', 'похожих квартиры', 'похожих квартир'])}
    </p>
  </div>`
}

export const get_catalog_select_item = (data) => {
  if (data) {
    return Object.entries(data).map(([value,title]) => `<li class="dropdown__list-item js-dropdown-list-item" data-value='${value}'>${title}</li>`)[0]
  }
}
